<script>
  export default {
    name: 'WhiteDialog',

    props: {
      value: {
        required: true,
      },
      contentClass: {
        type: String,
        default: '',
      },
    },

    data: () => ({
      dialog: false,
    }),

    watch: {
      value: {
        immediate: true,
        handler(val) {
          this.dialog = val;
        },
      },
      dialog(val) {
        this.$emit('input', val);
      },
    },
  };
</script>

<template>
  <v-dialog
    v-model="dialog"
    max-width="952"
    hide-overlay
    scrollable
    transition="dialog-transition"
    :content-class="contentClass"
  >
    <v-card class="white-dialog-card">
      <v-btn class="close-btn" icon @click="dialog = false" data-test-id="close-dialog">
        <v-icon>mdi-close-circle-outline</v-icon>
      </v-btn>

      <v-card-text>
        <slot name="content"></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
  .close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 1;
  }

  .white-dialog-card {
    background-color: white !important;
    border-radius: 20px;
    padding: 60px 80px;

    @media screen and (max-width: 600px) {
      padding: 40px 6px 0 0;
    }
  }
</style>
